import React, { FC } from 'react'
import {
  Icon,
  Button,
  ModalActions,
  ModalContent,
  Header,
} from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { LSPAYErrorMessage } from '../../helpers/lspay.types'
interface ErrorProps {
  lspayError: LSPAYErrorMessage
  disableRetry?: boolean
  retry: () => void
  close: () => void
  headingType?: 'heading' | 'sub-heading'
  showWarningIcon?: boolean
  isRetrying?: boolean
}

const ErrorContent: FC<ErrorProps> = ({
  lspayError,
  retry,
  close,
  disableRetry,
  headingType = 'heading',
  showWarningIcon,
  isRetrying,
}) => {
  const t = useT()
  const { header, body } = lspayError

  return (
    <>
      <ModalContent className="vd-mt0">
        <div className="vd-flex vd-flex--align-center vd-mt8">
          <Header type={headingType} level="2">
            {showWarningIcon && (
              <Icon
                icon="fa-exclamation-triangle"
                className="vd-pr2"
                style={{ color: 'red' }}
              />
            )}
            {header}
          </Header>
        </div>
        <div className="vd-mt8">{body}</div>
      </ModalContent>
      <ModalActions>
        <Button
          variant="supplementary"
          className="vd-mr2"
          onClick={() => close()}
          disabled={isRetrying}
          data-track="choose-another-payment-method"
        >
          {lspayError.action ||
            t('Choose a different payment method', {
              _context:
                'Button label for lightspeed payments error modal to choose a different payment method',
            })}
        </Button>
        {!disableRetry && (
          <Button
            data-track="retry-lspay-error-modal"
            onClick={retry}
            loading={isRetrying}
          >
            {lspayError.primaryAction ||
              t('Retry', {
                _context:
                  'Button label for lightspeed payments error modal to retry',
              })}
          </Button>
        )}
      </ModalActions>
    </>
  )
}

export { ErrorContent }
